import React from "react";
import {useTranslation} from "react-i18next";
import TabTitle from "../tabTitle/TabTitle";
import styled from "styled-components";
import LifeRanking from "./components/LifeRanking";
import NoLifeRanking from "./components/NoLifeRanking";
import './BranchClusteringStyles.css'
import TabHeader from "../tabHeader/TabHeader";
import TabFooter from "../tabFooter/TabFooter";
import HeaderContainer from "../Commons/HeaderContainer";
import BodyContainer from "../Commons/BodyContainer";
// @ts-ignore
import {animateScroll} from "react-scroll";

const BranchClusteringsContent = styled.div`
    @media (min-width: 481px) {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-top: 20px;
    }

    @media (max-width: 480px) {
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: scroll;
    }
`;

const tabContent = (
    <BranchClusteringsContent>
        <LifeRanking />
        <NoLifeRanking />
        <div className={'scollContainer'}>
            <span
              className={'homeScrollUpLogo'}
              onClick={() => { animateScroll.scrollToTop({ containerId: 'scrollContainer' }) }}
            >
              <span className='arrow' />
            </span>
        </div>
    </BranchClusteringsContent>
);

const BranchClusteringComponent: React.FC<{ isTabSelected: boolean }> = ({isTabSelected}) => {
    const { t } = useTranslation();

    return (
        <div id={'BranchClusteringContainer'} className={(isTabSelected ? 'openContainerBC' : 'closeContainerBC')}>
            {
                isTabSelected &&
                <HeaderContainer>
                    <TabHeader darkMode={true}/>
                </HeaderContainer>
            }
            <TabTitle
                title={ t('latamBranchConcentration.tabTitle') }
                isTabSelected={isTabSelected}
                darkMode={true}
            />
            <BodyContainer id='scrollContainer' className='scrollContainer'>
                {
                    isTabSelected && tabContent
                }
            </BodyContainer>
        </div>
    )
}

export default BranchClusteringComponent;
